import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IHttpResponse } from '../../models/IHttpResponse.interface';
import { HttpParamUtil } from '../../utils/http-param.util';

export abstract class  ModuleBaseService {
  protected baseApiUrl: string;
  protected moduleName: string;
  protected resourceName: string;
  protected http: HttpClient;

  constructor(http: HttpClient, baseApiUrl: string, moduleName: string, resourceName: string) {
    this.resourceName = resourceName;
    this.moduleName = moduleName;
    this.http = http;
    this.baseApiUrl = baseApiUrl;
  }  

  public GetAll<T>(entity?: T): Observable<IHttpResponse<T>> {
    const params = !!entity ? HttpParamUtil.ConvertToHttpParameters(entity) : null;  

    return this.http.get<IHttpResponse<T>>(    
      `${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}`, { params : params || {} });
  }

  public Get<T>(id: number): Observable<IHttpResponse<T>> {
    return this.http.get<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}/${id}`);
  }

  public GetById<T>(id: string): Observable<IHttpResponse<T>> {
    return this.http.get<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}/${id}`);
  }

  public SearchById<T>(id: number): Observable<IHttpResponse<T>> {
    return this.http.get<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}?Id=${id}`);
  }

  public Add<T>(entity: T): Observable<IHttpResponse<T>> {
    return this.http.post<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}`, entity);
  }

  public Update<T>(entity: T): Observable<IHttpResponse<T>> {
    return this.http.put<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}`, entity);
  }

  public UpdateById<T>(id: number, entity: T): Observable<IHttpResponse<T>> {
    return this.http.put<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}/${id}`, entity);
  }

  public Delete<T>(id: number): Observable<IHttpResponse<T>> {
    return this.http.delete<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}/${id}`);
  }

  public DeleteById<T>(id: string): Observable<IHttpResponse<T>> {
    return this.http.delete<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}/${id}`);
  }

  public DeleteEntity<T>(entity: T): Observable<IHttpResponse<T>> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: entity
    };
    return this.http.delete<IHttpResponse<T>>(`${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}`, options);
  }
}
